<template>
  <component :is="component" />
</template>

<script>
import RegisterPasswordTemplate from "../components/templates/RegisterPasswordTemplate.vue";
import RegisterBusinessTemplate from "../components/templates/RegisterBusinessTemplate.vue";
import RegisterWorkspaceTemplate from "../components/templates/RegisterWorkspaceTemplate.vue";
import { defineComponent } from "vue";
import httpManager from "@/app/shared/utils/httpManager";
export default defineComponent({
  components: {
    RegisterPasswordTemplate,
    RegisterBusinessTemplate,
    RegisterWorkspaceTemplate,
  },
  computed: {
    component() {
      const hasPassword = this.$store.getters["hasCustomerRegisterPassword"];
      const hasBusiness = this.$store.getters["hasCustomerRegisterBusinessName"];
      const stepWorkspace = this.$store.getters["getRegisterWorkspaceStep"];
      const basicInformation = hasPassword ? "business" : "password";
      const name = hasBusiness ? "workspace" : basicInformation;
      switch (stepWorkspace) {
        case 2:
          return RegisterPasswordTemplate;
        case 3:
          return RegisterBusinessTemplate;
        case 4:
          return RegisterWorkspaceTemplate;
        default:
          return `register-${name}-template`;
      }
    },
  },
  created() {
    localStorage.clear();
    httpManager.updateBaseURL(`https://backend.${import.meta.env.VITE_HOSTNAME}`);
    this.$store.commit("SET_TEMPORAL_FORM", null);
  },
});
</script>
